import type { ImpactStats } from '@/types';

// Supporter logos
import vetenskapsradetLogo from '@/assets/supporters/vetenskapsradet.webp';
import forteLogo from '@/assets/supporters/forte.webp';
import kempestiftelsernaLogo from '@/assets/supporters/kempestiftelserna.webp';
import umuLogo from '@/assets/supporters/umea-university.webp';
import regionVasterbottenLogo from '@/assets/supporters/region-vasterbotten.webp';

export const impactStats: ImpactStats = {
  totalPublications: 127,
  activeStudies: 8,
  participatingFamilies: 5243,
};

export const supporters = [
  { name: 'Vetenskapsrådet', logo: vetenskapsradetLogo, url: 'https://www.vr.se/' },
  { name: 'FORTE', logo: forteLogo, url: 'https://forte.se/' },
  { name: 'Kempestiftelserna', logo: kempestiftelsernaLogo, url: 'https://www.kempe.com/' },
  { name: 'Umeå Universitet', logo: umuLogo, url: 'https://www.umu.se/' },
  { name: 'Region Västerbotten', logo: regionVasterbottenLogo, url: 'https://www.regionvasterbotten.se/' },
];
